module.exports = __webpack_public_path__ + "img/logo-lecard.e9ebe59f.png";